import { Theme, styled } from '@material-ui/core';

const AddIconWrapper = styled('div')<Theme>(({ theme }) => ({
  position: 'absolute',
  top: '-0.1rem',
  right: '-0.1rem',
  width: '3rem',
  height: 'calc(100% + 0.2rem)',
  borderTopRightRadius: '0.3rem',
  borderBottomRightRadius: '0.3rem',
  background: theme.palette.primary.main,
}));

export default AddIconWrapper;
